/** Created by azhou on 2019/3/5.*/
<template>
    <div>
      <public-title showBack>匹配酒店列表</public-title>
      <!--匹配酒店结果信息-->
      <div class="load-area">
        <div class="text-left mb-4 p-2 rounded">
          <p class="d-center-start mb-2">
            <left-text leftText="共匹配酒店"/>
            <span class="text-danger mr-2">{{matchInfo.hotel_count}}</span>家
          </p>
          <p class="d-center-start mb-2">
            <left-text leftText="共匹配用户"/>
            <span class="text-danger mr-2">{{matchInfo.user_count}}</span>人
          </p>
          <p class="d-center-start mb-2">
            <left-text leftText="匹配城市"/><span class="ml-1">{{matchInfo.province_name}} {{matchInfo.city_name}}</span>
          </p>
          <p class="d-center-start mb-2">
            <left-text leftText="匹配区域"/>
            <span class="ml-1">{{matchInfo.district_name}}</span>
          </p>
          <p class="d-center-start ">
            <left-text leftText="匹配星级"/>
            <span class="text-warning mr-2 ml-1" :key="item"
              v-for="item in formatStars(matchInfo.star)">{{item}}</span>
          </p>
        </div>
        <el-tabs v-model="activeName" class="mb-4">
          <el-tab-pane name="99"><span slot="label">全部</span> </el-tab-pane>
          <el-tab-pane name="1"><span slot="label">推送成功<i class="ilue text-success">({{matchInfo.push_success}})</i></span> </el-tab-pane>
          <el-tab-pane name="2"><span slot="label">推送失败<i class="ilue text-danger">({{matchInfo.push_error}})</i></span> </el-tab-pane>
          <el-tab-pane name="0"><span slot="label">未绑定微信<i class="ilue text-warning ">({{matchInfo.no_wechat}})</i></span> </el-tab-pane>
          <!-- <el-tab-pane label="指定推送" name="appoint" /> -->
        </el-tabs>
        <search-con @getSearchCon="getSearchCon" v-show="activeName === 'appoint'" class="mb-4"/>
        <ul class="pt-1 pb-1 d-center-between border-bottom font-weight-bold text-blue">
          <li class="w-10">用户名称</li>
          <li class="w-10">通知状态</li>
          <li class="w-20">酒店名称</li>
          <li class="w-10">酒店星级</li>
          <li class="w-10">所在区域</li>
        </ul>
        <ul class="d-center-between border-bottom" v-for="(item,index) in hotelList" :key="index">
          <li class="w-10 pt-2 pb-2">
            <span >{{item.truename}}</span>
           <el-popover placement="right" trigger="hover">
              <div>
                  <span :class="[openid(item.match_uid,item.wechat_openid)?'text-success':'text-danger']">
                    {{openid(item.match_uid,item.wechat_openid)?'已绑定':'未绑定'}}
                    </span>
              </div>
              <i class="iconfont icon-weixin1 male" :class="[openid(item.match_uid,item.wechat_openid)  ? 'text-success' : 'text-muted']"  slot="reference" v-if="item.title!='无'"></i>
            </el-popover>
          </li>
          <li  class="w-10 pt-2 pb-2">
           <label  class="d-flex flex-column">
              <span :class="item.push_status==1? 'text-success' : 'text-danger'">{{push_status(item.push_status)}}</span>
            </label>
          </li>
          <li class="w-20 pt-2 pb-2">
             <span >{{item.hotel_title}}</span>
          </li>
          <li class="w-10 pt-2 pb-2">{{item.star | formatVar('HotelStar')}}</li>
          <li class="w-10 pt-2 pb-2">{{item.district_name}}</li>
        </ul>
        
        <el-pagination background layout="prev, pager, next" class="mt-4 text-center"
          v-if="hotelList.length > 0" :page-size="formData.num" :total="total" :current-page=formData.page
              @current-change="v => {this.formData.page=v; this.MatchLists()}"/>
        <p v-if="hotelList.length<=0" class="mt-3">当前没有数据</p>
        <div class="fliet">
        <el-button class="mt-4 " type="success" @click="informHotel" v-if="activeName==2">重发失败消息</el-button>
        </div>
      </div>
    </div>
</template>

<script>
  import { mapState, mapActions,mapMutations } from 'vuex'
  import SearchCon from '../../Admin/StoreManage/SearchCon'

  export default {
    name: 'Lists',
    components: { SearchCon },
    computed: {
      ...mapState(['orderMatchResult','AdminDataLists']),
      matchInfo() { return this.orderMatchResult.matchInfo },
      // //是否通知已匹配酒店
      status() { return this.orderMatchResult.status },
      chooseHotel() { //已选择通知的酒店id
        let choose = this.hotelList.filter(v => v.checked)
        return choose.map(v => v.id);
      }
    },
    watch:{
      // orderMatchResult(newVal) {
      //   if (!newVal.hotelList) return [];
      //   this.hotelList = newVal.hotelList.map(v => { v.checked = true; return v; })
      // },
      allHotel(newVal) { this.hotelList.forEach(v => v.checked = newVal); },
      //判断是否已全选
      chooseHotel(newVal) { this.allHotel = newVal.length === this.hotelList.length },
      //切换通知酒店报价的模式
      activeName(newVal) {
        this.formData.page = 1;
        this.formData.push_status = newVal!=99?newVal:'';
        // console.log(newVal)
         this.MatchLists();
        // let h = this.orderMatchResult.hotelList;
        // switch (newVal) {
        //   case 'system':this.hotelList = h ? h.map(v => { v.checked = true; return v; }) : []; break;
        //   case 'appoint':this.hotelList = []; break;
        // }
      }
    },

    created() {
      this.MatchLists();
    },
    destroyed() {
      this.UPDATECURRENTSTORE({type:''});
    },
    data() {
      return {
        allHotel:true,
        hotelList:[],
        activeName:'99',
        formData:{
          page:0,
          num:15,
          push_status:'',           //通知状态
        },

        
      }
    },
    methods:{
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['adminGetMatchLists','adminInformHotel','getAdminDataLists']),
      // 获取通状态
      push_status(val){
        switch (val*1) {
          case 0:
          return '未绑定'
          case 1:
          return '成功'
          case 2:
          return '无效的openid或没有关注该服务号'
          case 400:
          return '模板或token不合法'
          case 40003:
          return '无效的openid'
          case 43004:
          return '没有关注该服务号'
          case 4003:
          return '订阅模板id为空不正确'
          case 40013:
          return '无效的appid'
          case 40166:
          return '该appid不属于小程序类型'
          case 43101:
          return '用户拒绝接受消息，如果用户之前曾经订阅过，则表示用户取消了订阅关系'
          default:
          return '未知状态'
        }
      },
      //修改匹配酒店的选择状态
      changeHandle(val,index) {
        this.$set(this.hotelList,index,{...this.hotelList[index],checked:val})
      },
      openid(uid,wechat_openid){
        return wechat_openid==''||uid==wechat_openid?false:true;
      },
      formatStars(e){
        let result
        if(e=='')return['无']
        if(Array.isArray(e)){
          result=e
        }else{
          result=e.split(',')
        }
        let n=this.$options.filters['formatStars'](result)
        return n
      },
      //获取酒店匹配列表
      MatchLists(){
        let data={
          oid:this.$route.query.orderId,
          ...this.formData,
        }
        this.adminGetMatchLists({
          data,
          successFun: (res) => {
            this.hotelList = res.data.list || [];
            this.total = res.data.count || 0;
          }
        });
      },
      //通知酒店报价
      informHotel() {
        // if (this.chooseHotel.length <= 0) { this._alert('您还没有选择酒店',null,'error'); return }
        this._confirm('确定要重新发送么？',() => {
          this.adminInformHotel({
            oid:this.$route.query.orderId,
            // choose:this.chooseHotel,
            // check:this.activeName === 'system' ? 1 : 2,
            // display:1,
            // del:'0'
          })
        })
      },
      //搜索门店
      async getSearchCon(info) {
        // this.UPDATECURRENTSTORE({type:3});
        await this.getAdminDataLists({
          type:'storeList',
          data:{
            storeType:'3',
            num:100,
            ...info,
            type:3
          } 
        });
        let h = this.AdminDataLists.lists;
        this.hotelList = h.map(v => {
          v.checked = true;
          v.districtName = v.district_name;
          return v;
        });
      },
      //处理点击全选
      chooseAllHandle(val) {
        this.hotelList.forEach(v => v.checked = val);
      }
    }
  }
</script>
<style scoped>
    .fliet{
      float: right !important;
      overflow: hidden;
    }
    .w-4{
      width: 4%;
    }
    .ilue{
      margin-left: 2px;
      font-style: normal;
    }
    .male{
    margin-left: 4px;
    margin-top: 4px;
    font-size: 14px;
    cursor: pointer;
    display: inline-block;
    font-style: initial;
  }
</style>
